// extracted by mini-css-extract-plugin
export default {"selector":"zqBXqYUWHXeVDQuwxM4t","icon":"XVL6E8eONsLIsojv8mnX","text":"pphM4R8wtWeQzaLvq0bC"};